import { ADVERTS_HAS_ERRORED, ADVERTS_IS_LOADING, ADVERTS_STING_SERIES_FETCH_DATA_SUCCESS, ADVERTS_STING_PROGRAMME_FETCH_DATA_SUCCESS, ADVERTS_DISABLE_FETCH_DATA_SUCCESS, ADVERTS_STING_CAT_FETCH_DATA_SUCCESS } from '../actions/types';

export function advertsHasErrored(state = false, action) {
    switch (action.type) {
        case ADVERTS_HAS_ERRORED:
            return action.payload;
        default:
            return state;
    }
}

export function advertsIsLoading(state = false, action) {
    switch (action.type) {
        case ADVERTS_IS_LOADING:
            return action.payload;
        default:
            return state;
    }
}

export function stingSeriesIdItems(state = [], action) {
    switch (action.type) {
        case ADVERTS_STING_SERIES_FETCH_DATA_SUCCESS:
            return action.items;
        default:
            return state;
    }
}

export function stingProgrammeIdItems(state = [], action) {
    switch (action.type) {
        case ADVERTS_STING_PROGRAMME_FETCH_DATA_SUCCESS:
            return action.items;
        default:
            return state;
    }
}


export function stingCatIdItems(state = [], action) {
    switch (action.type) {
        case ADVERTS_STING_CAT_FETCH_DATA_SUCCESS:
            return action.items;
        default:
            return state;
    }
}

export function advertsDisableItems(state = [], action) {
    switch (action.type) {
        case ADVERTS_DISABLE_FETCH_DATA_SUCCESS:
            return action.items;
        default:
            return state;
    }
}
